{
  "cycle.entite.referentiel_revision_contributeurs": "Contributeurs des révisions du référentiel",
  "cycle.entite.referentiel_revisions": "Révisions du référentiel de l’organisation",
  "journalAudit.action.import.referential_applied": "Import d’axes appliqué : axes en brouillon soumis à la validation",
  "journalAudit.action.org_requirement.revision_saved": "Exigence de l’organisation : révision enregistrée",
  "journalAudit.action.org_requirement.withdrawn": "Exigence de l’organisation retirée (motif)",
  "journalAudit.action.referentiel.refused": "Révision du référentiel refusée",
  "journalAudit.action.referentiel.submitted": "Révision du référentiel soumise à la validation",
  "journalAudit.action.referentiel.validated": "Révision du référentiel validée",
  "journalAudit.action.referentiel.withdrawn_from_validation": "Révision du référentiel retirée de la validation",
  "journalAudit.action.taxonomy.axis_declared": "Axe déclaré en brouillon"
}
